(() => {
  document.addEventListener('change', event => {
    const selector = event.target.closest('[data-home-variant]');
    if (!selector) return;
    const card = selector.closest('.home-product-card');
    const option = selector.selectedOptions[0];
    const price = card?.querySelector('.price__current');
    if (price && option?.dataset.priceFormatted) price.textContent = option.dataset.priceFormatted;
  });
})();
